import { AlertStatesBaseCountersModel } from './alert-states-base-counters-model';

export class AlertStatesBaseGlobalConfigurationCountersModel extends AlertStatesBaseCountersModel {
}
